/* Home "Build Your Wall" row (Arjun 15-10: "Layout-la animate aagura images ... athe maari home page-layum animate aaganum").
   Each card is the builder gallery's picture (snippets/pz-home-byw-pic.liquid): the room photo with one empty sheet per spot.
   This fills the sheets with the layout's "Get this look" walls (assets/pz-byw-looks.json, the builder's own file) the same
   way the builder's layout cards do (pz-wall-builder.js railLkShow / railLkTick):
   - posters land one by one, biggest sheet first, in under 2 s, and the wall changes every 3 s;
   - each cycle ends with one empty turn: blank sheets pop in and a "Choose any poster" label lands on the wall;
   - cards start on different walls so they are never all empty together;
   - only cards on screen move; it stops after 24 switches (never resting on the empty turn); reduced motion = no motion.
   17-10 (Arjun: "Duo wall first three seconds ... apdiye irukku. Land aanavudane change panna mudiyum-nu kaattura maadhiri udane
   maaritte irukkanum"): every card runs on its own clock. Its first switch comes 0.5 s after it is on screen (it used to wait
   for the row's shared 3 s tick, so the wall in the HTML sat still ~3.5 s after landing), then every 3 s while it stays on
   screen. Off screen or in a background tab it pauses, and picks up again 0.5 s after it is back. Max 24 switches a card.
   The card link carries the wall on screen (&lk=N, or &lk=e on the empty turn), so a tap opens the builder with that wall. */
(function () {
  var root = document.querySelector('.pz-home-byw[data-looks]');
  if (!root || root.__pzhb) return;
  root.__pzhb = 1;
  var MS = 3000, FIRST = 500, MAX = 24, idx = {}, cur = {}, LOOKS = null, io = null, calm = false;
  try { calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  function thumb(s, w) { return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function cardOf(pic) {
    var key = pic.getAttribute('data-key'), spots = Array.prototype.slice.call(pic.querySelectorAll(':scope > i.pz-glk'));
    if (!key || !LOOKS || !LOOKS[key] || !LOOKS[key].length || !spots.length) return null;
    return { key: key, mini: pic, spots: spots, pk: pic.closest('.pk') };
  }
  function setLinks(c, n) {
    if (!c.pk) return;
    Array.prototype.forEach.call(c.pk.querySelectorAll('a[href]'), function (a) {
      var h = a.getAttribute('href').replace(/([?&])lk=[^&]*(&|$)/, function (m, p1, p2) { return p2 ? p1 : ''; }).replace(/[?&]$/, '');
      a.setAttribute('href', h + (h.indexOf('?') > -1 ? '&' : '?') + 'lk=' + (n < 0 ? 'e' : n));
    });
  }
  function show(c, animate) {
    var looks = LOOKS[c.key], L = looks.length, n = idx[c.key] || 0, slot = n % (L + 1);
    c.mini.setAttribute('data-pzlk', '1');
    var oldLab = c.mini.querySelector('.pz-lk-yours');
    if (slot === L) {   /* the empty turn */
      cur[c.key] = -1; setLinks(c, -1);
      c.spots.forEach(function (el) { el.classList.remove('pz-lk-on'); });
      var bx0 = Infinity, by0 = Infinity, bx1 = 0, by1 = 0;
      var ordE = c.spots.map(function (el, i) {
        bx0 = Math.min(bx0, el.offsetLeft); by0 = Math.min(by0, el.offsetTop);
        bx1 = Math.max(bx1, el.offsetLeft + el.offsetWidth); by1 = Math.max(by1, el.offsetTop + el.offsetHeight);
        return { i: i, a: el.offsetWidth * el.offsetHeight, y: el.offsetTop, x: el.offsetLeft };
      }).sort(function (p, q) { return (q.a - p.a) || (p.y - q.y) || (p.x - q.x); });
      var stepE = Math.min(90, Math.floor(1200 / Math.max(1, c.spots.length)));
      setTimeout(function () {
        ordE.forEach(function (o, k) { var el = c.spots[o.i]; el.style.setProperty('--pzd', (animate ? k * stepE : 0) + 'ms'); el.classList.add('pz-lk-blank'); });
        if (oldLab && oldLab.parentNode) oldLab.parentNode.removeChild(oldLab);
        var lab = document.createElement('span');
        lab.className = 'pz-lk-yours';
        lab.textContent = 'Choose any poster';
        if (bx1 > bx0) { lab.style.left = ((bx0 + bx1) / 2) + 'px'; lab.style.top = ((by0 + by1) / 2) + 'px'; }
        c.mini.appendChild(lab);
      }, animate ? 260 : 0);
      looks[0].items.forEach(function (it) { var w = new Image(); w.src = thumb(it.img, 160); });
      return;
    }
    var lk = looks[slot];
    if (!lk || !lk.items || lk.items.length !== c.spots.length) return;
    cur[c.key] = slot; setLinks(c, slot);
    if (oldLab && oldLab.parentNode) oldLab.parentNode.removeChild(oldLab);
    c.spots.forEach(function (el) { el.classList.remove('pz-lk-blank'); });
    var order = c.spots.map(function (el, i) { return { i: i, a: el.offsetWidth * el.offsetHeight, y: el.offsetTop, x: el.offsetLeft }; })
      .sort(function (p, q) { return (q.a - p.a) || (p.y - q.y) || (p.x - q.x); });
    var step = Math.min(110, Math.floor(1600 / Math.max(1, c.spots.length)));
    var put = function () {
      order.forEach(function (o, k) {
        var el = c.spots[o.i], it = lk.items[o.i], im = el.querySelector('img.pz-lk');
        if (!im) { im = document.createElement('img'); im.className = 'pz-lk'; im.alt = ''; im.decoding = 'async'; el.appendChild(im); }
        im.src = thumb(it.img, 160);
        el.style.setProperty('--pzd', (animate ? k * step : 0) + 'ms');
      });
      void c.mini.offsetWidth;   /* a forced layout starts the transitions (rAF stalls in a background tab) */
      c.spots.forEach(function (el) { el.classList.add('pz-lk-on'); });
    };
    var was = c.spots[0].classList.contains('pz-lk-on');
    if (was && animate) { c.spots.forEach(function (el) { el.classList.remove('pz-lk-on'); }); setTimeout(put, 260); }
    else put();
    var nx = looks[slot + 1];
    if (nx && nx.items) nx.items.forEach(function (it) { var w = new Image(); w.src = thumb(it.img, 160); });
  }
  function plan(pic, ms) {
    if (calm || pic.__pzT || pic.__pzDone) return;
    pic.__pzT = setTimeout(function () { pic.__pzT = 0; step(pic); }, ms);
  }
  function stop(pic) { if (pic.__pzT) { clearTimeout(pic.__pzT); pic.__pzT = 0; } }
  function step(pic) {
    var c = cardOf(pic); if (!c) return;
    if (document.hidden || (io && !pic.__pzVis)) return;   /* paused: the observer / visibilitychange start it again */
    var n = pic.__pzN || 0;
    if (n >= MAX) {
      if (cur[c.key] === -1) { idx[c.key] = (idx[c.key] || 0) + 1; show(c, true); }
      pic.__pzDone = 1; return;
    }
    idx[c.key] = (idx[c.key] || 0) + 1; show(c, true); pic.__pzN = n + 1;
    plan(pic, MS);
  }
  function start() {
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var pic = e.target; pic.__pzVis = e.isIntersecting;
          if (e.isIntersecting) plan(pic, FIRST); else stop(pic);
        });
      }, { threshold: 0.35 });
    }
    Array.prototype.forEach.call(root.querySelectorAll('.pz-hb-pic[data-key]'), function (pic, ci) {
      var c = cardOf(pic); if (!c) return;
      /* 15-10 ("First 3 sec ku poster varla"): the first wall comes baked into the HTML (data-lk = its look); carry on from it */
      if (pic.getAttribute('data-lk') != null && pic.querySelector('i.pz-lk-on')) {
        idx[c.key] = +pic.getAttribute('data-lk') || 0; cur[c.key] = idx[c.key]; setLinks(c, idx[c.key]);
      } else {
        idx[c.key] = ci % LOOKS[c.key].length; show(c, !calm);
      }
      if (io) io.observe(pic); else { pic.__pzVis = true; plan(pic, FIRST); }
    });
    document.addEventListener('visibilitychange', function () {
      Array.prototype.forEach.call(root.querySelectorAll('.pz-hb-pic[data-key]'), function (pic) {
        if (document.hidden) stop(pic); else if (!io || pic.__pzVis) plan(pic, FIRST);
      });
    });
  }
  function boot() {
    var x = new XMLHttpRequest();
    x.open('GET', root.getAttribute('data-looks'), true);
    x.timeout = 10000;
    x.onload = function () {
      var j = null;
      try { j = JSON.parse(x.responseText); } catch (e) {}
      if (x.status !== 200 || !j || !j.looks) return;
      LOOKS = j.looks;
      start();
    };
    x.send();
  }
  /* the walls list (the builder's own file, brotli on the CDN) is asked for at once - the cards already show their first
     wall from the HTML, so this only feeds the next ones (15-10: waiting for window load left the sheets empty ~3 s) */
  boot();
})();
